import { defineComponent as u, openBlock as s, createBlock as f, resolveDynamicComponent as h, createElementBlock as a, Fragment as m, renderList as p, createElementVNode as d, toDisplayString as c, createTextVNode as g } from "vue";
function _(t) {
  const r = ["", "k", "m", "b", "t"], e = Math.log10(Math.abs(t)) / 3 | 0;
  if (t.toString().length <= 4 || e === 0)
    return {
      value: t
    };
  if (t.toString().length === 15)
    return {
      value: x(t, 1e12),
      suffix: "t"
    };
  if (t.toString().length > 15)
    return {
      value: 999.99,
      suffix: "t+"
    };
  const n = t / Math.pow(10, e * 3);
  return {
    value: M(n, t),
    suffix: r[e]
  };
}
function M(t, r) {
  const e = r.toString().length;
  return e > 6 ? parseFloat(t.toFixed(2)) : e < 7 ? Math.trunc(t) : parseFloat(t.toFixed(1));
}
function x(t, r) {
  const e = t / r;
  return Math.trunc(100 * e) / 100;
}
const V = /* @__PURE__ */ u({
  __name: "CardTitle",
  props: {
    title: {},
    heading: { default: "h3" }
  },
  setup(t) {
    return (r, e) => (s(), f(h(r.heading), {
      class: "Title",
      innerHTML: r.title
    }, null, 8, ["innerHTML"]));
  }
}), S = { class: "Metrics" }, L = /* @__PURE__ */ u({
  __name: "CardMetricList",
  props: {
    metrics: {},
    thousandToK: { type: Boolean }
  },
  setup(t) {
    const r = t, e = (n) => {
      const o = _(n);
      return r.thousandToK ? `${o.value ? o.value : 0}${o.suffix || ""}` : n.toLocaleString();
    };
    return (n, o) => (s(), a("ul", S, [
      (s(!0), a(m, null, p(n.metrics, (i, l) => (s(), a("li", {
        key: l,
        class: "Metrics__Item"
      }, [
        d("b", null, c(e(Number(i.value))), 1),
        g(" " + c(i.text), 1)
      ]))), 128))
    ]));
  }
});
export {
  V as _,
  L as a,
  _ as f
};
